import { modalEmptySourceState } from 'Pages/Campaign/recoil/state/modals'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const ModalEmptySource = () => {
  const intl = useIntl()
  const [{ show }, setShow] = useRecoilState(modalEmptySourceState)

  const handleClick = () => {
    setShow((prev) => ({ ...prev, show: false }))
  }

  return (
    <Modal
      data-mu-test='modal__empty-source'
      show={show}
      showClose
      onClose={handleClick}
      closeOnOverlayClick
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ContentsCampaignWizard.ModalNoDataTitle'
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.ContentsCampaignWizard.ModalNoDataDescr'
        })}
      </ModalBody>
      <ModalFoot>
        <Button variant={BUTTON_VARIANT_PRIMARY} onClick={handleClick}>
          {intl.formatMessage({ id: 'Load.ModalConfermeDelete.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalEmptySource
